import Actions from './actions';

import * as Reducers from './reducers';

import ProtectedRoute from '../../components/ProtectedRoute';
import FilesPage from './components/FilesPage';

import { MY_FILES_PATH } from '../../constants/routes';

const Routes = [
  {
    path: MY_FILES_PATH,
    Component: ProtectedRoute,
    loader: () => [Actions.Files.loadIfNeeded()],
    children: [
      {
        index: true,
        Component: FilesPage,
      },
    ],
  },
];

export default {
  Actions,
  Reducers,
  Routes,
};
